import { render, staticRenderFns } from "./MovimentoConsolidado.vue?vue&type=template&id=3fa972ce"
import script from "./MovimentoConsolidado.vue?vue&type=script&lang=ts"
export * from "./MovimentoConsolidado.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports